import React, { useEffect, useState } from "react";
import customLayout from "assets/images/png/login-layout-img02.png";
import customLogo from "assets/images/svg/click-for-marry02.svg";
import { Form } from "antd";
import { authLayoutText } from "../accountFor/helper";
import BrandLogo from "assets/images/svg/click-for-marry02.svg";
import AuthLayout from "components/Authentication/components/authLayout";
import Input from "components/BaseWidgets/form/input";
import Password from "components/BaseWidgets/form/password";
import Button from "components/BaseWidgets/button";
import ReferralModal from "components/CustomWidgets/referralModal";
import { CloseIconPrimary } from "assets/icons";
import "./style.scss";
import { useCreateAccount } from "hooks/api/useAuth";
import AccountFor from "../accountFor";
import { useLocation, useNavigate } from "react-router-dom";
import { retrieveToken } from "utils/storage";

function CreateAccount() {
  const referral = retrieveToken("referral");
  const [openModal, setOpenModal] = useState(false);
  const [referralCode, setReferralCode] = useState(referral ? referral : "");
 
  useEffect(() => {
    if (referral) {
      setOpenModal(true);
    }
  }, [referral]);

  const [form] = Form.useForm();
  const [isAccountFor, setAccountFor] = useState(false);
  const location = useLocation();
  const countryCode = location.state?.userData?.Countrycodes;
  const contact = location.state?.userData?.contact;
  const name = location.state?.userData?.name;
  const profileFor = location.state?.userData?.profileFor;
  const showAccountFor = location.state?.showAccountFor;

  const navigate = useNavigate();
  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (hash === "google_auth" && location.state) {
      setAccountFor(true);
    }
  }, [location.hash]);

  const { mutate: register, isPending } = useCreateAccount({
    onSuccess: () => {
      setAccountFor(true);
    },
  });

  const onFinish = (value) => {
    const formField = {
      identifier: value.identifier,
      password: value.password,
      confirm_password: value.confirmPassword,
      name: name,
      profile_created_for: profileFor,
    };

    if (referralCode && referralCode.length >= 0) {
      formField.refer_code = referralCode;
    }

    if (countryCode?.value) {
      formField.countrycode = countryCode.value;
    }

    register(formField);
  };

  return (
    <AuthLayout
      isCustomText={true}
      Logo={customLogo}
      layoutImage={customLayout}
      line1={authLayoutText.line1}
      line2={authLayoutText.line2}
      line3={authLayoutText.line3}
    >
      <div className="login-wrapper create-account-wrapper">
        <div className="brand-logo">
          <img className="logo" src={BrandLogo} alt="Logo" />
        </div>
        {isAccountFor || showAccountFor ? (
          <AccountFor
            name={location.state.name ? location.state.name : name}
            profileFor={
              location.state.profileFor ? location.state.profileFor : profileFor
            }
          />
        ) : (
          <>
            <div className="page-heading">
              <h1 className="title font-title-xl mb-2">Create an account</h1>
              <p className="subtitle font-body-xs">Find your true companion.</p>
            </div>
            <div className="auth-form-container">
              <Form
                form={form}
                className="login-form"
                onFinish={onFinish}
                layout="vertical"
                initialValues={{ identifier: contact }}
              >
                <Form.Item
                  name="identifier"
                  className="custom-error identifier-field"
                  rules={[{ required: true, message: "Please enter your ID" }]}
                >
                  {countryCode?.label && contact && !contact.includes("@") && (
                    <label
                      htmlFor="identifier"
                      className="label identifier-label"
                    >
                      Phone number or Email ID
                    </label>
                  )}

                  <div className="identifier-container">
                    {countryCode?.label &&
                      contact &&
                      !contact.includes("@") && (
                        <div className="country-code">{countryCode?.label}</div>
                      )}

                    <Input
                      id="identifier"
                      labelClass={`${
                        countryCode?.label && contact && !contact.includes("@")
                          ? ""
                          : "label"
                      }`}
                      label={
                        countryCode?.label && contact && !contact.includes("@")
                          ? ""
                          : "Phone number or Email ID"
                      }
                      value={contact}
                      readOnly={contact}
                    />
                  </div>
                </Form.Item>

                <Form.Item
                  name="password"
                  className="custom-error"
                  rules={[
                    { required: true, message: "Please enter your password!" },
                    {
                      validator: (_, value) => {
                        if (value) {
                          const strongPasswordRegex =
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
                          if (!strongPasswordRegex.test(value)) {
                            return Promise.reject(
                              "Password must be at least 8 characters long, include uppercase, lowercase, number, and special character!"
                            );
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Password
                    id="password"
                    labelClass="label"
                    label="Password"
                    className="mt-2"
                    placeholder=""
                    isPreventAutoFill
                  />
                </Form.Item>

                <Form.Item
                  name="confirmPassword"
                  dependencies={["password"]}
                  className="custom-error"
                  rules={[
                    {
                      validator: (_, value) => {
                        const strongPasswordRegex =
                          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

                        if (!value) {
                          return Promise.reject(
                            "Please confirm your password!"
                          );
                        }
                        if (!strongPasswordRegex.test(value)) {
                          return Promise.reject(
                            "Password must be at least 8 characters long, include uppercase, lowercase, number, and special character!"
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                    // Match with password
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Passwords do not match!")
                        );
                      },
                    }),
                  ]}
                >
                  <Password
                    id="confirm-password"
                    labelClass={`label`}
                    label="Confirm Password"
                    className="mt-6"
                    placeholder=""
                    isPreventAutoFill
                  />
                </Form.Item>

                <Button
                  isLoading={isPending}
                  htmlType="submit"
                  className={"mt-8"}
                  wFull
                >
                  Continue
                </Button>
              </Form>
              <div className="mt-5 flex flex-col gap-4 ">
                <span className="register-text font-body-xs">
                  Already have an account?
                  <Button
                    onClick={() => navigate("/login")}
                    className="register-link"
                    variant="link"
                  >
                    Log in
                  </Button>
                </span>
                <span className="register-text font-body-xs">
                  Do you have a referral code?
                  <Button
                    onClick={() => {
                      setOpenModal(true);
                      setReferralCode(referral);
                    }}
                    className="register-link"
                    variant="link"
                  >
                    Click here
                  </Button>
                </span>
              </div>
            </div>
          </>
        )}
      </div>
      <ReferralModal
        type="invite"
        open={openModal}
        referralCode={referralCode}
        setReferralCode={setReferralCode}
        width={538}
        onCancel={() => setOpenModal(false)}
        closeIcon={<CloseIconPrimary />}
        handleRefer={(data) => {
          setReferralCode(data);
          setOpenModal(false);
        }}
        className={`invite-modal`}
        wrapClassName={`invite-modal`}
        title={
          <>
            You’re invited! <br />
            Join click4marry & find your match!
          </>
        }
        description={`You’ve joined through a referral from a friend!`}
      />
    </AuthLayout>
  );
}

export default CreateAccount;
